var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9629 32C25.7994 32 32.9629 24.8366 32.9629 16C32.9629 7.16344 25.7994 0 16.9629 0C8.12633 0 0.962891 7.16344 0.962891 16C0.962891 24.8366 8.12633 32 16.9629 32Z",
    fill: "#4467AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0441 14.0489C18.2646 13.8001 18.4471 13.5488 18.6746 13.3331C19.3739 12.6741 20.1988 12.3423 21.1635 12.3518C21.6945 12.3565 22.2183 12.3944 22.728 12.5414C23.8966 12.8804 24.5769 13.6839 24.8992 14.8264C25.141 15.6821 25.186 16.5615 25.1884 17.4433C25.1908 19.3041 25.1837 21.1648 25.1884 23.0232C25.1884 23.1962 25.141 23.2436 24.968 23.2412C24.0103 23.2341 23.0503 23.2341 22.0927 23.2412C21.9244 23.2412 21.8889 23.1915 21.8889 23.0303C21.8936 21.2596 21.896 19.4913 21.8889 17.7207C21.8889 17.2774 21.858 16.8341 21.7348 16.4027C21.5049 15.6086 20.936 15.2033 20.104 15.2484C18.9686 15.3076 18.376 15.8718 18.2314 17.0261C18.1958 17.3011 18.1792 17.5784 18.1816 17.8558C18.1816 19.5767 18.1816 21.2975 18.1863 23.0208C18.1863 23.1915 18.1437 23.2436 17.9683 23.2412C17.0035 23.2318 16.0388 23.2341 15.0717 23.2412C14.9176 23.2412 14.8726 23.2009 14.8726 23.0445C14.8773 19.6359 14.8773 16.2273 14.8726 12.8211C14.8726 12.6528 14.9271 12.6125 15.0859 12.6149C16.0032 12.622 16.9182 12.622 17.8355 12.6149C18.0038 12.6149 18.0489 12.667 18.0441 12.8282C18.0346 13.2359 18.0417 13.6436 18.0417 14.0513L18.0441 14.0489Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7935 17.9459C12.7935 19.6312 12.7911 21.3189 12.7982 23.0042C12.7982 23.1915 12.7532 23.2484 12.5588 23.246C11.6012 23.2365 10.6436 23.2389 9.68593 23.246C9.53185 23.246 9.48682 23.2081 9.48682 23.0493C9.49156 19.6359 9.49156 16.2226 9.48682 12.8069C9.48682 12.6647 9.52 12.6149 9.67171 12.6173C10.6436 12.6244 11.6154 12.6244 12.5873 12.6173C12.7745 12.6173 12.7982 12.6884 12.7982 12.8472C12.7935 14.5467 12.7959 16.2463 12.7959 17.9482L12.7935 17.9459Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0567 9.23251C13.0567 10.2921 12.1986 11.1525 11.1414 11.1549C10.0984 11.1549 9.23326 10.2921 9.22852 9.24911C9.22615 8.19429 10.0913 7.32674 11.1462 7.32911C12.1939 7.32911 13.0543 8.18955 13.0567 9.23251Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.962891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.4ecfb4cd25b0210f1a039c4cff851c4e.svg";
export { ForwardRef as ReactComponent };